import { calculateTotalCurrentMortgageAmount } from '../utils/Operations';

export class CashOut {
  constructor(cashReq, estHomeVal, cashMort, ltv, currentMortgageAmount, refiReason = '') {
    this.cashReq = cashReq;
    this.estHomeVal = estHomeVal;
    this.cashMort = cashMort;
    this.ltv = ltv;
    this.currentMortgageAmount = currentMortgageAmount;
    this.refiReason = refiReason;
  }

  // This static method should only be used when we get data from VALUE CHECK
  static setFromValueCheck(data = {}) {
    const cashReq = 0;
    const estHomeVal = parseFloat(data.estimatedHomeValue) || 0;
    const cashMort = calculateTotalCurrentMortgageAmount(data);
    const ltv = estHomeVal > 0 ? parseFloat(((cashMort / estHomeVal) * 100).toFixed(2)) : 0;
    return new CashOut(
      cashReq,
      estHomeVal,
      cashMort,
      ltv,
      cashMort,
    );
  }
}
